import React, { useEffect, useState, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import styles from './EduMine.module.less';
import classNames from 'classnames';
import ScrollTop from '../../../components/ScrollTop/ScrollTop';
import InfinteScroll from '../../../components/InfinteScroll/GridInfinteScroll';
import {
  getEducationMineGradelist,
  setEducationMineError,
  setEducationMineLoading,
  deleteEducationMineGradeList,
} from '../../../actions/education';
import Toast from '../../../components/Toast/Toast';
import Loading from '../../../components/Loading/Loading';
import { useHistory, useLocation, Link } from 'react-router-dom';
import { CONTEXT } from '../../../config';
import EduCard from '../../../components/EduCard/EduCard';
import eduBlank from '../../../static/edu_blank.svg';
import Btn from '../../../components/Btn/Btn';
import { logging, logPostInfo } from '../../../actions/log';
import qs from 'query-string';
import KeepAlive, { useActivate, useUnactivate } from 'react-activation';
import { education } from '../../../constants/storageKeys';

const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
const SelectMineInfo = createSelector(
  state => state.education,
  educations => educations.mine,
);
const selectUserInfo = createSelector(
  state => state.user,
  user => user.userInfo,
);
function Edumine() {
  const tabInfo = {
    nodata: {
      course: '学习中的',
      collect: '收藏的',
      pay: '购买的',
    },
    nologin: {
      course: '已学的',
      collect: '收藏的',
      pay: '购买的',
    },
  };
  const location = useLocation();
  const search = qs.parse(location.search);
  const [loginStatus, setLoginStatus] = useState(false);
  const [activeTab, setActiveTab] = useState((search && search.tagId) || 'course');
  const [loading, setLoading] = useState(false);
  const [initTime, setInitTime] = useState(null);
  const { gradeList, pagenation, error } = useSelector(SelectMineInfo);
  const userInfo = useSelector(selectUserInfo);

  const dispatch = useDispatch();
  const history = useHistory();

  const logInfoData = useSelector(selectLogInfo);

  // 浏览时长打桩
  const leaveTimeLog = () => {
    const leaveTime = +new Date();
    dispatch(
      logging({
        category: 'I',
        action: 'View_Time',
        label: '',
        param2: {
          source: `Edu_Mine`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          initTime,
          leaveTime,
          time: leaveTime - initTime,
          age_period: localStorage.getItem(education.EDUSTAGE),
        },
      }),
    );
  };

  useEffect(() => {
    setInitTime(+new Date());
    return () => {
      leaveTimeLog();
    };
  }, []);

  useActivate(() => {
    setInitTime(+new Date());
  });

  useUnactivate(() => {
    leaveTimeLog();
  });
  const pvLog = () => {
    // 打桩--页面展现
    dispatch(
      logging({
        category: 'P',
        action: 'Edu_Mine',
        label: '',
        param2: {
          source: `Edu_Mine`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          age_period: localStorage.getItem(education.EDUSTAGE),
        },
      }),
    );
    dispatch(
      logPostInfo({
        source: 'Edu_Mine',
        source_p: logInfoData.source,
        source_pp: logInfoData.source_p,
      }),
    );
  };

  useEffect(() => {
    pvLog();
  }, []);

  useActivate(() => {
    pvLog();
  });

  // 写入登录状态
  useEffect(() => {
    if (!window.CallNativeMethod) {
      return;
    }
    const userId = window.CallNativeMethod('get_user_id');
    const loginST = window.CallNativeMethod('get_st');
    if (loginST !== '' && userId) {
      // 登录
      setLoginStatus(true);
    } else {
      setLoginStatus(false);
    }
  }, [userInfo]);

  const handleLogin = () => {
    window.CallNativeMethod('login'); // 未登录 调用登录弹窗
    dispatch(
      logging({
        category: 'C',
        action: 'Edu_Mine_Login',
        label: '',
        param2: {
          source: `Edu_Mine`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          age_period: localStorage.getItem(education.EDUSTAGE),
        },
      }),
    );
  };

  const getData = refresh => {
    if (activeTab && loginStatus) {
      dispatch(
        getEducationMineGradelist({
          refresh,
          tab: activeTab,
          limit: 24,
          skip: pagenation.tab === activeTab && !refresh ? (gradeList && gradeList.length) || 0 : 0,
        }),
      );
      dispatch(setEducationMineLoading(true));
    }
  };

  useEffect(() => {
    if (error && location.pathname === `${CONTEXT}/education/mine`) {
      dispatch(setEducationMineError(false));
      history.replace(`${CONTEXT}/error`);
    }
  });

  useEffect(() => {
    getData(true);
  }, [activeTab, loginStatus]);

  const initPage = () => {
    setActiveTab((search && search.tagId) || 'course');
    setLoading(true);
    const timer = setTimeout(() => {
      setLoading(false);
      clearTimeout(timer);
    }, 200);
  };

  useEffect(() => {
    initPage();
  }, []);

  useActivate(() => {
    if (history.action === 'PUSH') {
      initPage();
    }
  });

  const handleTab = param => () => {
    let source = 'collect';
    if (param === 'course') {
      source = 'collect';
    } else if (param === 'collect') {
      source = 'Learning';
    } else if (param === 'pay') {
      source = 'Pay';
    }

    setActiveTab(param);

    dispatch(
      logging({
        category: 'C',
        action: 'Edu_Mine_Tab',
        label: '',
        param2: {
          source: `Edu_Mine||${source}`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
          age_period: localStorage.getItem(education.EDUSTAGE),
        },
      }),
    );
  };

  const loadMore = () => {
    getData();
  };

  const handleDeleteGrade = param => {
    dispatch(
      deleteEducationMineGradeList({
        tab: activeTab,
        [activeTab === 'course' ? 'myCourserIds' : 'myCollectIds']: [
          {
            courserId: param && param.courseId,
          },
        ],
      }),
    );
  };

  const handleLink = () => {
    dispatch(
      logging({
        category: 'C',
        action: 'Edu_Mine_Random',
        label: '',
        param2: {
          source: `Edu_Mine`,
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  };
  // studyState 0:进入详情页面，1： 进入详情页面并顺序播放， 2：进入详情页面重头播放
  const handleCard = useCallback(
    (e, data, studyState) => {
      e.stopPropagation();
      // 该课程已下架
      if (data && data.status && data.status === 3) {
        Toast.error({
          content: '该课程已下架，请选择其它课程',
        });
        return;
      }
      dispatch(
        logging({
          category: 'C',
          action: 'Edu_Mine_Pay',
          label: '',
          param2: {
            source: logInfoData.source,
            source_p: logInfoData.source_p,
            source_pp: logInfoData.source_pp,
            courseid: data.courseId,
            age_period: localStorage.getItem(education.EDUSTAGE),
            discountPrice: (data.discountPrice / 100).toFixed(2),
          },
        }),
      );
      dispatch(
        logPostInfo({
          source_p: logInfoData.source,
          source_pp: logInfoData.source_p,
        }),
      );

      history.push(
        `${CONTEXT}/edudetail?courseId=${data.courseId}&bizInfo=${data.bizInfo ||
          '{}'}&studyState=${studyState}`,
      );
    },
    [logInfoData],
  );

  const handleCustomer = useCallback(() => {
    // window.open('tencent://message/?v=3&uin=3007422128&site=在线客服&menu=yes');
    window.open(`https://wpa1.qq.com/z914HEIy?_type=wpa&qidian=true}`);
  }, []);

  let firstHeight = 263 + 52 + 19;
  if (activeTab === 'course') {
    firstHeight = 263 + 52 + 19;
  } else if (activeTab === 'collect') {
    firstHeight = 263 + 52 + 19;
  } else if (activeTab === 'pay') {
    firstHeight = 212 + 52 + 10;
  }

  const Header = () => {
    return (
      <div className={styles.header}>
        <div
          className={classNames(styles.header_tab, {
            [styles.header_tab_active]: activeTab === 'course',
          })}
          onClick={handleTab('course')}
        >
          在学课程
        </div>
        <div
          className={classNames(styles.header_tab, {
            [styles.header_tab_active]: activeTab === 'collect',
          })}
          onClick={handleTab('collect')}
        >
          收藏课程
        </div>
        <div
          className={classNames(styles.header_tab, {
            [styles.header_tab_active]: activeTab === 'pay',
          })}
          onClick={handleTab('pay')}
        >
          已购买课程
        </div>
        {activeTab === 'pay' && (
          <div className={styles.header_customer}>
            订单有异常？
            <span className={styles.header_customer_qq} onClick={handleCustomer}>
              联系我们
            </span>
          </div>
        )}
      </div>
    );
  };

  if (loading && history.action !== 'POP') {
    return (
      <div className={styles.edumine}>
        <div className={styles.loading}>
          <Loading />
        </div>
      </div>
    );
  }

  if (!loginStatus) {
    return (
      <div className={styles.edumine}>
        <Header />
        <img className={styles.nodata} src={eduBlank} alt=""></img>
        <div className={styles.nodata_text}>
          登录后查看{tabInfo.nologin[activeTab] || ''}课程<br></br>
          <Btn primary className={styles.login} handleClick={handleLogin}>
            立即登录
          </Btn>
        </div>
      </div>
    );
  }

  if (pagenation && pagenation.loading && pagenation.tab !== activeTab) {
    return (
      <div className={styles.edumine}>
        <Header />
        {loginStatus && (
          <div className={styles.loading_content}>
            <Loading />
          </div>
        )}
      </div>
    );
  }

  return (
    <div className={styles.edumine}>
      <div>
        <InfinteScroll
          dataSource={[...gradeList]} // 数据集
          count={pagenation.count}
          height={540} // 高
          width={835} // 宽
          minimumBatchSize={3} // 一行最多统一时间加载个数 默认10
          threshold={3} // 预加载个数
          getItemSize={index =>
            index !== 0
              ? (activeTab === 'course' && 263) ||
                (activeTab === 'collect' && 263) ||
                (activeTab === 'pay' && 212)
              : firstHeight
          } // 行高
          loadData={loadMore}
          column={activeTab === 'pay' ? 1 : 3}
          template={(item, index) => {
            return activeTab === 'pay' ? (
              <div className={styles.edumine_pay}>
                <img
                  className={styles.edumine_pay_img}
                  src={item.imgUrl}
                  alt=""
                  onClick={e => {
                    handleCard(e, item, 0);
                  }}
                />
                <div className={styles.edumine_pay_infos}>
                  <div
                    className={styles.edumine_pay_title}
                    title={item.name}
                    onClick={e => {
                      handleCard(e, item, 0);
                    }}
                  >
                    {item.name}
                  </div>
                  <div className={styles.edumine_pay_line}>订单号：{item.orderId}</div>
                  <div className={styles.edumine_pay_line}>支付时间：{item.successTime}</div>
                  <div className={styles.edumine_pay_line}>
                    支付金额：{(item.payAmount / 100).toFixed(2)}
                  </div>
                  <div className={styles.edumine_pay_line}>
                    支付方式：{item.payType === 'WX' ? '微信支付' : '支付宝支付'}
                  </div>
                  <div className={styles.edumine_pay_line}>
                    支付状态：
                    <span className={styles.edumine_pay_success}>
                      {item.orderStatus === 10 ? '支付成功' : '支付失败'}
                    </span>
                  </div>
                </div>
                <div className={styles.edumine_pay_opt}>
                  {(!item.status || item.status === '1') && (
                    <div
                      className={styles.edumine_pay_btn}
                      onClick={e => {
                        handleCard(e, item, 1);
                      }}
                    >
                      继续学习
                    </div>
                  )}
                  {item.status === '2' && (
                    <div
                      className={styles.edumine_pay_btn}
                      onClick={e => {
                        handleCard(e, item, 2);
                      }}
                    >
                      重新学习
                    </div>
                  )}
                  {item.status === '3' && <div className={styles.edumine_pay_off}>已下架</div>}
                </div>
              </div>
            ) : (
              <div
                className={classNames(styles.zt_card, {
                  [styles.zt_card_center]: index % 3 === 1,
                })}
              >
                <EduCard
                  data={item}
                  tag="left"
                  hasDelete
                  handleDelete={handleDeleteGrade}
                  type={activeTab === 'course' ? 'learning' : 'reading'}
                  log={{
                    action:
                      activeTab === 'course'
                        ? (item.status === '1' && 'Edu_Mine_Continue') ||
                          (item.status === '2' && 'Edu_Mine_Relearn') ||
                          null
                        : null,
                    source: activeTab === 'course' ? 'Edu_Mine||Learn' : 'Edu_Mine||Collect',
                  }}
                ></EduCard>
              </div>
            );
          }}
          tpl={Header}
        />
      </div>

      {pagenation.loading && pagenation.count === 0 && gradeList.length === 0 && (
        <div className={styles.loading}>
          <Loading />
        </div>
      )}
      {!pagenation.loading && pagenation.count === 0 && gradeList.length === 0 && (
        <>
          <img className={styles.nodata} src={eduBlank} alt=""></img>
          <div className={styles.nodata_text}>
            目前还没有{tabInfo.nodata[activeTab] || ''}课程哦！
            <Link to={`${CONTEXT}/education/recommend`} className={styles.link}>
              <span onClick={handleLink}>随便逛逛</span>
            </Link>
          </div>
        </>
      )}
      <ScrollTop />
    </div>
  );
}

export default () => (
  <KeepAlive name="Edumine">
    <Edumine></Edumine>
  </KeepAlive>
);
